import { render, staticRenderFns } from "./ModuleAccessWalletSoftware.vue?vue&type=template&id=331799ea&class=AccessSoftwareWallet"
import script from "./ModuleAccessWalletSoftware.vue?vue&type=script&lang=js"
export * from "./ModuleAccessWalletSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports